<template>
  <div class="home">
    <b-container fluid class="p-0 overflow-hidden">
      <TopBarMember />
    </b-container>
    <b-container class="p-0 p-sm-3 overflow-hidden">
      <b-row>
        <b-col cols="12">
          <LottoMenu />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import TopBarMember from "@/components/TopBarMember.vue";
import LottoMenu from "@/components/LottoMenu.vue";

export default {
  name: "Lottery",
  components: {
    TopBarMember,
    LottoMenu
  }
}
</script>
